import Frames from "@fae/source/engine/animating/Frames.js"

export default {
    "frames": Frames.run({
        "tweentime": 80,
        "images": [
            require("./spawneranim-monored-0000.png"),
            require("./spawneranim-monored-0001.png"),
            require("./spawneranim-monored-0002.png"),
            require("./spawneranim-monored-0003.png"),
            require("./spawneranim-monored-0004.png"),
            require("./spawneranim-monored-0005.png"),
            require("./spawneranim-monored-0006.png"),
            require("./spawneranim-monored-0007.png"),
            require("./spawneranim-monored-0008.png"),
            require("./spawneranim-monored-0009.png"),
            require("./spawneranim-monored-0010.png"),
            require("./spawneranim-monored-0011.png"),
            require("./spawneranim-monored-0012.png"),
            require("./spawneranim-monored-0013.png"),
            require("./spawneranim-monored-0014.png"),
            require("./spawneranim-monored-0015.png"),
        ]
    })
}
